// @flow

const setCookie = (
  id: string,
  value: string,
  maxAge: number,
  path: string = '/'
) => {
  try {
    const maxAgeValue = maxAge ? `; max-age=${maxAge}` : '';
    document.cookie = `${id}=${value}${maxAgeValue}; path=${path}`;
  } catch (e) {
    console.error('Unable to set cookie', { id });
  }
};

export default setCookie;
